<div class="ref-list-container">
  @for (ref of refs; track ref; let idx = $index; let count = $count) {
    <div
      class="d-flex justify-content-center align-items-center bg-success text-white border rounded-circle cursor-pointer"
      [popoverTitle]="popoverTitle"
      [ngbPopover]="popoverContent"
      placement="bottom"
      autoClose="outside"
      [style.z-index]="count - idx">
      <span [class.small-citation]="ref.citation > 99">{{ ref.citation }}</span>

      <ng-template #popoverTitle>
        Source:
        <a [href]="ref.url" target="blank">{{ ref.url | shortDomain }}</a>
      </ng-template>

      <ng-template #popoverContent>
        <app-short-content
          [content]="ref.content"
          [length]="200"></app-short-content>
      </ng-template>
    </div>
  }
</div>
